<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload = "handleReload"
                     @edit = "handleEdit"
                     btn_copy
                     @copy="handleCopy"
                     btn_review
                     @review="handleReview"
                     :btn_extra_batch="[{name:'批量设置会议组',type:'info',icon:'el-icon-edit'}]"
                     @extra="handleExtra"
        >
            <div class="pull-right">
                <el-button type="text" icon="el-icon-coffee-cup" @click="showBatchCreateWindow">批量复制房间</el-button>
            </div>
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields"
                     @success="handleSuccess" @cancel="handleCancel"></edit-dialog>

        <div class="clearfix"></div>

        <!--批量界面-->
        <el-dialog :visible.sync="batch" title="批量复制房间">
            <el-form ref="form" :model="payload" label-width="160px" @submit.native.prevent>
                <el-form-item label="复制对象:">
                    <el-select v-model="payload.id" placeholder="请选择" size="medium" filterable class="w-100">
                        <el-option
                                v-for="(label,value) in rooms"
                                :key="value"
                                :label="label"
                                :value="value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="复制到数值:">
                    <el-input-number v-model="payload.max" size="medium" :min="2" :max="9999"></el-input-number>
                </el-form-item>
                <el-form-item label="*">
                    <div class="text-info">不用理提示的错误，刷新页面查看生成的会议室.</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="">
                <slot name="footer"></slot>
                <el-button @click="batch=false" size="medium" icon="el-icon-close">返回</el-button>
                <el-button type="primary" :loading="process.loading" size="medium" @click="generateRooms">批量生成</el-button>
            </div>
        </el-dialog>


        <el-dialog title="批量设置组" :visible.sync="batch_open" width="70%">
            <div class="text-center mb-4 text-info">
                <div class="font-weight-bold">待设置的id:{{batch_ids}}</div>
                <div class="mt-5">
                    <el-select v-model="group_id" filterable clearable placeholder="请选择会议室组">
                        <el-option v-for="x in groups" :key="x.id" :value="x.id" :label="x.id+'|'+x.name"></el-option>
                    </el-select>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="doBatchAssign"  type="default" class="mr-3" icon="el-icon-edit">设置</el-button>
                <el-button @click="batch_open = false" icon="el-icon-close" type="primary">返 回</el-button>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="view_mode" width="85%">
            <div slot="title" class="text-primary">
                ({{single.name}}) |
                {{single.email}}
            </div>
            <div>
                <el-form :model="single" @submit.native.prevent label-width="180px">
                    <el-form-item label="正在进行的会议:" class="mb-0">
                        <div class="font-weight-bold" v-if="single.live">
                            {{single.live.id}} | {{single.live.topic}}
                            <el-button size="mini" type="danger" @click="endLive" class="ml-5">关闭</el-button>
                        </div>
                        <div v-else>没有正在进行的会议.</div>
                    </el-form-item>
                    <div class="line"></div>
                    <el-table size="small"
                              :data="schedules"
                              height="250"
                              style="width: 100%">
                        <el-table-column v-for="header in headers" :key="header.prop"
                                         :prop="header.prop"
                                         :label="header.label">
                        </el-table-column>
                        <el-table-column :label="('操作')" :width="80">
                            <template slot-scope="scope">
                                <el-button  type="success" size="mini"
                                           @click="handleOpen(scope.row)" circle icon="el-icon-s-promotion"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="" @click="view_mode = false">确 定</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins:[FrontMixins],
        name: 'admin-zoom-rooms',
        components: {FrontTable, EditDialog},
        data() {
            return {
                batch: false,
                payload: {id:'1',max:2},
                rooms: {},
                batch_open:false,
                batch_ids:[],
                group_id:null,
            }
        },
        created() {
            this.model = 'Admin.ZoomRoom';
        },
        methods:{
            endLive() {
                if (this.single.live) {
                    this.$api(this.model + '.Lock', {
                        'id': this.single.id,
                        'meeting_id': this.single.live.id
                    }, 1).then(() => {
                        this.$notice.success(('关闭完成!'));
                    });
                }
            },
            handleOpen(row) {
                this.$api(this.model+'.Unlock',row,1).then(() => {
                    this.$notice.success(('开启完成!'));
                });
            },
            generateRooms() {
                const vm = this;
                this.$api(this.model+'.publish',this.payload,1).then((res)=>{
                    vm.$notice.success(res.data.data);
                    vm.batch = false;
                });
            },
            showBatchCreateWindow() {
                const vm = this;
                this.$api(this.model+'.RoomAsOptions',this.payload,1).then((res)=>{
                    vm.rooms = res.data.data;
                    this.batch = true;
                });
            },
            doBatchAssign(){
                const vm = this;
                this.$api(this.model+'.AssignGroup',{ids:this.batch_ids,group_id:this.group_id},1).then(()=>{
                    vm.batch_open = false;
                    vm.$notice.success('修改完成');
                    vm.reload();
                });
            },
            handleExtra(obj){
                this.batch_ids = obj.ids;
                this.batch_open = true;
            }
        },
        computed:{
            schedules() {
                if (this.single.schedules) return this.single.schedules;
                return [];
            },
            headers() {
                return [{label: '时间', prop: 'good_time'}, {label: '会议号', prop: 'meeting_id'},
                    {label: '密码', prop: 'password'}, {label: '主题', prop: 'topic'},{label: '主持人', prop: 'host_name'}];
            },
            groups(){
                return this.preset.app.room_groups;
            }
        }
    }

</script>

<style lang="scss">

</style>
